import { render } from "./SimpleTable.vue?vue&type=template&id=d971db72&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"

import "./SimpleTable.vue?vue&type=style&index=0&id=d971db72&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d971db72"]])

export default __exports__